module.exports = __webpack_public_path__ + "media/images/font/Gustavo-BoldItalic-c9a68dc23a9e2121c5f68af55ae5e5bd.woff2";